export default "/images/fd1368ede8580224e0ac1cacc8d38ea9.jpg";